<template>
    <slot />
</template>

<script setup>
    import { useModelExporter } from '#imports';
    import { computed, ref, watch } from 'vue';

    import { basePaneOptions, usePane, useRafBool } from '@resn/gozer-vue';

    import { useBasketball } from '../../common/Objects/useBasketball';
    import { useSceneObject } from './useSceneObject';

    const props = defineProps({
        visible: { type: Boolean, default: false },
        object: { type: Object, default: null, required: true },
        layer: { type: Number, default: 0 },
        s: { type: Number, default: 0.95 },
        x: { type: Number, default: 0 },
        y: { type: Number, default: 0 },
        z: { type: Number, default: 0 },
        rx: { type: Number, default: -0.48 },
        ry: { type: Number, default: 0.45 },
        rz: { type: Number, default: 0.44 },
    });

    const active = computed(() => props.visible);

    const ballColor = ref('#e2692c');

    const object = props.object;

    const rx = ref(props.rx);
    const ry = ref(props.ry);
    const rz = ref(props.rz);
    const px = ref(props.x);
    const py = ref(props.y);
    const pz = ref(props.z);
    const s = ref(props.s);

    const { ballMaterial, outline } = useBasketball({ object });

    outline.overrideProps = { metalness: 1, roughness: 0 };

    useSceneObject({
        object,
        props,
        objectProps: { rx, ry, rz, px, py, pz },
        name: 'Basketball',
    });

    watch(ballColor, (val) => {
        ballMaterial.color.set(val);
    });

    useRafBool(active, ({ delta }) => {
        // ball.rotation.z += (delta / 1000) * 0.3;
        // outline.rotation.z += (delta / 1000) * 0.3;
    });

    const modelExport = useModelExporter();

    if (!modelExport) {
        // usePane(
        //     [
        //         { name: 'ballColor', value: ballColor },
        //         // { name: 'showNormals', value: showNormals },
        //         { name: 's', value: s, options: basePaneOptions },
        //         { name: 'px', value: px, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'py', value: py, options: { min: -1, max: 1, step: 0.01 } },
        //         { name: 'pz', value: pz, options: { min: -4, max: 1, step: 0.01 } },
        //         { name: 'rx', value: rx },
        //         { name: 'ry', value: ry },
        //         { name: 'rz', value: rz },
        //     ],
        //     {
        //         title: 'Basketball',
        //         expanded: false,
        //     }
        // );
    }
</script>
